import { render, staticRenderFns } from "./SearchActions.vue?vue&type=template&id=04c35053"
import script from "./SearchActions.vue?vue&type=script&lang=js"
export * from "./SearchActions.vue?vue&type=script&lang=js"
import style0 from "./SearchActions.vue?vue&type=style&index=0&id=04c35053&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports